import ApiCaller from '../utils/apiCaller'

import Toggles from '@domain/toggles/Toggles';
import BaseBOM from '@domain/catalog/BaseBOM';
import Space from '@domain/composition/Space';

type bodyType = {
    config: object
    catalogId: string,
    products: BaseBOM["props"]
    projectId?: number | null
    name?: string | null
}

class ProjectApi {
    constructor() { }

    static async addToProject(space: Space, catalog: string, BOM: BaseBOM, projectId: string | null, name: string | null = null) {
        const body: bodyType = {
            "config": space.toJSON(),
            "catalogId": catalog,
            "products": [BOM.props],
        }
        projectId != null ? body["projectId"] = parseInt(projectId) : null;
        name != null ? body["name"] = name : null;
        return await ApiCaller.call('v2', 'POST', `project`, body, { credentials: 'include' })
    }

    static async getProjects() {
        return await ApiCaller.call('projects', 'GET', `v1/projects?type=LIST&lang=es`, null, { credentials: 'include' })
    }

    /**
     * Lectura del proyecto para el flujo EDIT de los configuradores.
     *
     * v3 devuelve el mismo cuerpo plano que v2 (`sendSuccessResponse` hace `res.send(data)`),
     * así que los consumidores no cambian. Detrás de `fixProjectV3insteadV2` para poder
     * volver a v2 sin deploy.
     */
    static async getProjectById(id: string) {
        const version = Toggles.isEnabled('fixProjectV3insteadV2') ? 'v3' : 'v2'
        return await ApiCaller.call(version, 'GET', `project/${id}`, null, { credentials: 'include' })
    }
}

export default ProjectApi